import JSZip from "jszip";

const downloadImagesAsZip = async (imageUrls, zipFilename) => {
  const zip = new JSZip();

  await Promise.all(
    imageUrls.map(async (url, index) => {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch ${url}`);
      }
      const blob = await response.blob();
      const filename = decodeURIComponent(url.split("/").pop()) || `image-${index + 1}`;
      zip.file(filename, blob);
    })
  );

  const zipBlob = await zip.generateAsync({ type: "blob" });
  const downloadUrl = URL.createObjectURL(zipBlob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = zipFilename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(downloadUrl);
};

export default downloadImagesAsZip;
